/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches
const HAS_HIGH_CONTRAST = window.matchMedia('(forced-colors: active)').matches || window.matchMedia('(prefers-contrast: more)').matches
const PREFERS_REDUCED_MOTION = (() => {
    const prefersReducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion)');
    prefersReducedMotionMediaQuery.addEventListener('change', () => { window.location.reload() });
    return prefersReducedMotionMediaQuery.matches;
})();

// Main environment variables
const ENV = Object.freeze({
    // Node environment
    NAME: NODE_ENV,
    IS_PROD: NODE_ENV === 'production',
    IS_DEV: NODE_ENV === 'development',
    HAS_HIGH_CONTRAST,

    // Device
    IS_MOBILE,
    IS_DESKTOP: !IS_MOBILE,
    PREFERS_REDUCED_MOTION,

    // Supports
    SUPPORTS_VH: (
        'CSS' in window
        && 'supports' in window.CSS
        && window.CSS.supports('height: 100svh')
        && window.CSS.supports('height: 100dvh')
        && window.CSS.supports('height: 100lvh')
    )
})

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
    FIRST_LOADED: 'is-first-loaded',
    LOADING: 'is-loading',
    LOADING_FRAGMENT: 'is-loading-fragment',
    LOADED: 'is-loaded',
    READY: 'is-ready',
    REPLACING: 'is-replacing',
    REPLACING_FRAGMENT: 'is-replacing-fragment',
    REPLACING_PAGE: 'is-replacing-page',
    FONTS_LOADED: 'fonts-loaded',
    LAZY_CONTAINER: 'c-lazy',
    LAZY_LOADED: '-lazy-loaded',
    HAS_NO_JS: 'has-no-js',
    HAS_JS: 'has-js',
    // ...
})

// Custom js events
const CUSTOM_EVENT = Object.freeze({
    RESIZE_END: 'loco.resizeEnd',
    VISIT_START: 'visit.start',
    MODAL_OPEN: 'modal.open',
    // ...
})

// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        // { family: 'Echonova Bloc', style: 'normal', weight: 400 },
        // { family: 'Echonova Dot', style: 'normal', weight: 400 },
        // { family: 'Echonova Flex', style: 'normal', weight: 400 },
        { family: 'Echonova Easy', style: 'normal', weight: 400 },
        { family: 'Studio Feixen Sans', style: 'normal', weight: 400 },
        { family: 'Studio Feixen Sans', style: 'normal', weight: 700 }
    ],
})

export {
    ENV,
    CSS_CLASS,
    CUSTOM_EVENT,
    FONT
}